import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonLogoRoutingModule } from './common-logo-routing.module';
import { CommonLogoComponent } from './common-logo.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { VesselQuestionnairePopupModule } from 'src/app/shared/components/vessel-questionnaire-popup/vessel-questionnaire-popup.module';

@NgModule({
  declarations: [CommonLogoComponent],
  imports: [CommonModule, CommonLogoRoutingModule, MaterialModule, FormsModule, NgxUiLoaderModule, VesselQuestionnairePopupModule],
  exports: [CommonLogoComponent],
})
export class CommonLogoModule {}
